import { render, staticRenderFns } from "./MakeList.vue?vue&type=template&id=9c16e35e&scoped=true&"
import script from "./MakeList.vue?vue&type=script&lang=js&"
export * from "./MakeList.vue?vue&type=script&lang=js&"
import style0 from "./MakeList.vue?vue&type=style&index=0&id=9c16e35e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c16e35e",
  null
  
)

export default component.exports